import { render, staticRenderFns } from "./overallCampaignsPieChart.vue?vue&type=template&id=aa6b0e6e&scoped=true&"
import script from "./overallCampaignsPieChart.vue?vue&type=script&lang=js&"
export * from "./overallCampaignsPieChart.vue?vue&type=script&lang=js&"
import style0 from "./overallCampaignsPieChart.vue?vue&type=style&index=0&id=aa6b0e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6b0e6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
